import type { Location, CurrentWeather } from '@miweather/shared';

interface PlaceSchemaProps {
  location: Location;
  current: CurrentWeather;
}

export function PlaceSchema({ location, current }: PlaceSchemaProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Place",
    "name": `${location.name}, Michigan`,
    "description": `Weather for ${location.name}, Michigan: ${current.conditions}, ${current.temperature ?? '--'}°F`,
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": location.coordinates.lat,
      "longitude": location.coordinates.lon
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": location.name,
      "addressRegion": "MI",
      "addressCountry": "US"
    },
    "url": `https://miweather.org/weather/${location.id}`
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

interface BreadcrumbSchemaProps {
  items: Array<{ name: string; url: string }>;
}

export function BreadcrumbSchema({ items }: BreadcrumbSchemaProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
